import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiServices from '../services/ApiServices';
import { ShowSuccessToast, ShowDangerToast } from '../services/toast';
import { Eye, EyeOff, Loader2 } from 'lucide-react';

const LoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await ApiServices.postData('/auth/login', { email, password });
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('role', response.data.role);
      ShowSuccessToast('Login successful!');

      if (response.data.role === 'superadmin') {
        navigate('/admin');
      }
       else if (response.data.role === 'store_owner') {
          if (response?.data?.stores?.length > 0) {
            localStorage.setItem('stores', JSON.stringify(response.data.stores));
            localStorage.setItem('selectedStoreId', response.data.stores[0].id.toString());
            navigate(`/store/${response.data.stores[0].id}`);
          } else {
            ShowDangerToast('No stores found for this account');
          }
        }
         else if (response.data.role === 'store_manager') {
          if (response?.data?.storeId) {
            localStorage.setItem('storeId', response.data.storeId.toString());
            navigate(`/store/${response?.data?.storeId}`);
          } else {
            ShowDangerToast('No store assigned to this manager');
          }
        } else {
          ShowDangerToast('Unauthorized role');
        }

    } catch (error) {
      ShowDangerToast('Login failed. Please check your credentials.');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-navy-50 via-gray-50 to-navy-100 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="/logo-full.png"
            alt="Donor Dispatch"
            className="h-24 mx-auto mb-2"
          />
        </div>

        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8">
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-navy-800">Welcome back</h2>
            <p className="text-gray-500 mt-1 text-sm">Sign in to your account to continue</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="input-label">Email</label>
              <input
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-field"
                required
                autoComplete="email"
              />
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label className="input-label">Password</label>
                <a
                  href="mailto:support@donordispatch.com?subject=Password%20Reset%20Request"
                  className="text-xs text-navy-500 hover:text-navy-700 transition-colors"
                >
                  Forgot password?
                </a>
              </div>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="input-field pr-11"
                  required
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="w-full btn-primary py-3 text-base flex items-center justify-center gap-2 mt-2"
              disabled={loading}
            >
              {loading && <Loader2 className="w-5 h-5 animate-spin" />}
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>

        <p className="text-center text-xs text-gray-400 mt-6">
          Powered by Donor Dispatch
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
